import CarouselV2 from "../../components/CarouselV2";
import SelectorEngine from "../../utils/dom/selector-engine";
import CustomComponent from "../CustomComponent";

export class CarouselV2Component extends CustomComponent {
  static key = 'lta-carousel-v2';

  style() {
    return `
        .card {
          background-color: #fff;
          padding: 10px;
          margin: 10px;
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
          border: 1px solid #e0e0e0;
          border-radius: 10px;
        }
        .carousel-v2-wrapper {
          display: flex;
          flex-direction: column;
        }
    `;
  }

  static get observedAttributes() {
    return ['id', 'classes', 'slides-xl', 'slides-md', 'slides-sm'];
  }

  render(childrenHTML) {
    const { id, slidesXl = '2', slidesMd = '2', slidesSm = '1', classes = '' } = this.props;
    return `
      <div class="lta-carouselv2 ${classes}" id="${id}"
        ${slidesXl ? `data-slides-per-view-xl="${slidesXl}"` : ''}
        ${slidesMd ? `data-slides-per-view-md="${slidesMd}"` : ''}
        ${slidesSm ? `data-slides-per-view-sm="${slidesSm}"` : ''}>
        <div class="swiper">
            <div class="swiper-wrapper">
              ${childrenHTML}
            </div>
            <div class="lta-carouselv2__controls">
              <button class="lta-carouselv2__prev u-mr-2">
                  <svg class="lta-icon js-lta-text-input--btn-icon" width="2rem" height="2rem" style="color:currentColor;" fill="currentColor" alt="arrow-left-circle" aria-hidden="true">
                    <use xlink:href="/static/images/icons/lta-icons.svg#arrow-left-circle"></use>
                  </svg>
              </button>
              <div class="lta-carouselv2__pagination u-hstack u-gap-1"></div>
              <button class="lta-carouselv2__next u-ml-2">
                  <svg class="lta-icon js-lta-text-input--btn-icon" width="2rem" height="2rem" style="color:currentColor;" fill="currentColor" alt="arrow-right-circle" aria-hidden="true">
                    <use xlink:href="/static/images/icons/lta-icons.svg#arrow-right-circle"></use>
                  </svg>
              </button>
            </div>
            <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
        </div>
      </div>
    `
  }

  beforeRender() {
    // console.log('beforeRender', this.props.id);
  }

  afterRender() {
    const carouselsv2 = SelectorEngine.findOne(`.lta-carouselv2`, this);
    const carousel = CarouselV2.getOrCreateInstance(carouselsv2);
    carousel?.update();
  }
}

export default CarouselV2Component;